import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Alert,
  Snackbar,
  Box,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { decrypt } from "../../../components/cryptoUtil";
import { Heading } from "../../componenet/heading";
import { API_BASE_URL } from "../../../constant/constant";


const genders = ["Male", "Female", "Other"];
const maritalStatus = ["Single", "Married", "Other"];
const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
const employmentTypes = ["Permanent", "Contract", "Temporary"];
const staffCategories = ["Doctor", "Nurse", "Technician", "Admin", "Support"];
const statusOptions = ["Active", "On Leave", "Retired", "Resigned"];
const shifts = ["Morning", "Evening", "Night"];

export default function StaffProfile() {
  let decryptedData = {};
  const token = localStorage.getItem("token");
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch {
    decryptedData = {};
  }


  const hospitalcode = (decryptedData.softsubgroup || "").toString().toUpperCase();


const [searchTerm, setSearchTerm] = useState("");








  const [tabIndex, setTabIndex] = useState(0);
  const [staffId, setStaffId] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", dob: "", gender: "", bloodGroup: "", maritalStatus: "", email: "", mobile: "",
    employeeId: "New", department: "", jobTitle: "", dateOfJoining: "", employmentType: "", staffCategory: "", status: "", shift: "",
    currentAddress: "", permanentAddress: "", city: "", state: "", zip: "", altContact: "",
    salary: "", bankName: "", bankBranch: "", accountNumber: "", ifsc: "",
    vaccination: [], allergies: "", medicalHistory: "", healthCheckFile: null,
    attendanceId: "", leaveBalance: "", leaveEntitlement: "", shiftPreference: "",
    username: "", password: "", accessRights: [],
    registrationNumber: "", specialization: "", consultationFees: "", degree: "", hospitalID: ""
  });

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [specializations, setSpecializations] = useState([]);
  const [loadingSpecializations, setLoadingSpecializations] = useState(true);
  const [employeeList, setEmployeeList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [hospitalID, sethospitalID] = useState('');
  const handleTabChange = (e, newVal) => setTabIndex(newVal);
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") setFormData((prev) => ({ ...prev, [name]: files[0] }));
    else if (name === "vaccination" || name === "accessRights") setFormData((prev) => ({ ...prev, [name]: value.split(",") }));
    else setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // 1: ["employeeId", "department", "jobTitle", "dateOfJoining", "employmentType", "staffCategory", "status", "shift", "degree"],

  const baseRequiredFieldsPerTab = {
    0: ["firstName", "lastName", "dob", "gender", "bloodGroup", "maritalStatus", "email", "mobile"],
    1: ["department", "jobTitle", "dateOfJoining", "employmentType", "staffCategory", "status", "degree"],
    2: [], 3: [], 4: [], 5: [],
    6: ["username", "password"],
  };
  const requiredFieldsPerTab = JSON.parse(JSON.stringify(baseRequiredFieldsPerTab));
  if (formData.staffCategory === "Doctor") {
    ["registrationNumber", "specialization", "consultationFees"].forEach(f => {
      if (!requiredFieldsPerTab[1].includes(f)) requiredFieldsPerTab[1].push(f);
    });
  } else {
    requiredFieldsPerTab[1] = requiredFieldsPerTab[1].filter(f => !["registrationNumber", "specialization", "consultationFees"].includes(f));
  }

  const isTabInvalid = (tabIndex) => {
    const fields = requiredFieldsPerTab[tabIndex] || [];
    return fields.some(f => !formData[f]);
  };

  // Fetch all staff list
  const fetchStaffList = async (hospitalId) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/hospital/getAllStaff/${hospitalcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      // console.log(data);
      if (Array.isArray(data)) setEmployeeList(data);
    } catch (err) {
      console.error("Error fetching staff list:", err);
    }
  };


  useEffect(() => {
    fetchStaffList();
  }, []);

  // Fetch specializations
  useEffect(() => {
    const fetchSpecializations = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/hospital/specialization`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (Array.isArray(data)) setSpecializations(data);
      } catch (err) {
        console.error("Error fetching specializations:", err);
      } finally { setLoadingSpecializations(false); }
    };
    fetchSpecializations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = new FormData();


    // If not a Doctor, clear doctor-specific fields
    if (formData.staffCategory !== "Doctor") {
      formData.registrationNumber = "";
      formData.specialization = "";
      formData.consultationFees = 0;
    }


    // Object.entries({ ...formData, hospitalID: hospitalcode }).forEach(([key, value]) => {
    //   if (key === "specialization" && formData.staffCategory !== "Doctor") {
    //     body.append(key, "");
    //   } else if (Array.isArray(value)) {
    //     body.append(key, value.join(","));
    //   } else if (value instanceof File) {
    //     body.append(key, value);
    //   } else {
    //     body.append(key, value || "");
    //   }
    // });

    Object.entries({ ...formData, hospitalID: hospitalcode }).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        body.append(key, value.join(","));
      } else if (value instanceof File) {
        body.append(key, value);
      } else {
        body.append(key, value ?? ""); // use ?? for null/undefined
      }
    });

    // if (staffId) body.append("id", staffId);

    try {
      const res = await fetch(`${API_BASE_URL}/api/hospital/saveStaff`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body,
      });
      const data = await res.json();
      if (res.ok) {
        setSnackbar({ open: true, message: data.message || "Staff profile saved successfully!", severity: "success" });
        // reset form after save
        setFormData({
          firstName: "", lastName: "", dob: "", gender: "", bloodGroup: "", maritalStatus: "", email: "", mobile: "",
          employeeId: "New", department: "", jobTitle: "", dateOfJoining: "", employmentType: "", staffCategory: "", status: "", shift: "",
          currentAddress: "", permanentAddress: "", city: "", state: "", zip: "", altContact: "",
          salary: "", bankName: "", bankBranch: "", accountNumber: "", ifsc: "",
          vaccination: [], allergies: "", medicalHistory: "", healthCheckFile: null,
          attendanceId: "", leaveBalance: "", leaveEntitlement: "", shiftPreference: "",
          username: "", password: "", accessRights: [],
          registrationNumber: "", specialization: "", consultationFees: "", degree: "",
        });
        setStaffId(null);
        setTabIndex(0);
        fetchStaffList();
      } else {
        setSnackbar({ open: true, message: data.message || "Failed to save staff profile", severity: "error" });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Error saving staff profile", severity: "error" });
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`; // YYYY-MM-DD
  };



  // const handleEdit = (staff) => {
  //   setFormData({ ...staff });
  //   setStaffId(staff.id);
  //   setTabIndex(0);
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // };



  const handleEdit = (staff) => {



    setFormData({
      ...staff,
      dob: formatDate(staff.dob),
      dateOfJoining: formatDate(staff.dateOfJoining),
    });
    setStaffId(staff.staff_id);
    setTabIndex(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };




  const handleDelete = async (staff) => {
    if (!window.confirm("Are you sure you want to delete this staff member?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/hospital/deleteStaff/${staff.staff_id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok) {
        setSnackbar({ open: true, message: "Staff deleted successfully!", severity: "success" });
        fetchStaffList();
      } else {
        setSnackbar({ open: true, message: data.message || "Delete failed", severity: "error" });
      }
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Error deleting staff", severity: "error" });
    }
  };

  const rowStyle = { display: "flex", flexWrap: "wrap", gap: "20px", marginBottom: "20px" };
  const itemStyle = { flex: "1 1 calc(33% - 20px)", minWidth: "200px" };

  // Tabs rendering kept same

  // --- TAB CONTENTS ---
  const renderPersonalInfo = (
    <div style={rowStyle}>
      <TextField label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} required style={itemStyle} />
      <TextField label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} required style={itemStyle} />
      <TextField label="Date of Birth" name="dob" type="date" value={formData.dob} onChange={handleChange} InputLabelProps={{ shrink: true }} required style={itemStyle} />
      <FormControl required style={itemStyle}><InputLabel>Gender</InputLabel><Select name="gender" value={formData.gender} onChange={handleChange}>{genders.map(g => <MenuItem key={g} value={g}>{g}</MenuItem>)}</Select></FormControl>
      <FormControl required style={itemStyle}><InputLabel>Blood Group</InputLabel><Select name="bloodGroup" value={formData.bloodGroup} onChange={handleChange}>{bloodGroups.map(b => <MenuItem key={b} value={b}>{b}</MenuItem>)}</Select></FormControl>
      <FormControl required style={itemStyle}><InputLabel>Marital Status</InputLabel><Select name="maritalStatus" value={formData.maritalStatus} onChange={handleChange}>{maritalStatus.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}</Select></FormControl>


      <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required disabled={!!staffId} style={itemStyle} />




      <TextField label="Mobile Number" name="mobile" type="tel" value={formData.mobile} onChange={handleChange} required style={itemStyle} />
    </div>
  );

  const renderEmployment = (
    <div style={rowStyle}>
      <TextField label="Employee ID" name="employeeId" value={formData.employeeId} onChange={handleChange} required style={itemStyle} disabled />



      <TextField label="Department" name="department" value={formData.department} onChange={handleChange} required style={itemStyle} />
      <TextField label="Job Title" name="jobTitle" value={formData.jobTitle} onChange={handleChange} required style={itemStyle} />
      <TextField label="Date of Joining" name="dateOfJoining" type="date" value={formData.dateOfJoining} onChange={handleChange} InputLabelProps={{ shrink: true }} required style={itemStyle} />
      <FormControl required style={itemStyle}><InputLabel>Employment Type</InputLabel><Select name="employmentType" value={formData.employmentType} onChange={handleChange}>{employmentTypes.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}</Select></FormControl>
      <FormControl required style={itemStyle}><InputLabel>Staff Category</InputLabel><Select name="staffCategory" value={formData.staffCategory} onChange={handleChange}>{staffCategories.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}</Select></FormControl>
      <FormControl required style={itemStyle}><InputLabel>Status</InputLabel><Select name="status" value={formData.status} onChange={handleChange}>{statusOptions.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}</Select></FormControl>

      {/*       
      <FormControl required style={itemStyle}><InputLabel>Shift</InputLabel><Select name="shift" value={formData.shift} onChange={handleChange}>{shifts.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}</Select></FormControl>
      */}

      <TextField label="Educational Degree" name="degree" value={formData.degree} onChange={handleChange} style={itemStyle} />
      {formData.staffCategory === "Doctor" && (
        <>
          <TextField label="Registration Number" name="registrationNumber" value={formData.registrationNumber} onChange={handleChange} style={itemStyle} />
          <FormControl required style={itemStyle}>
            <InputLabel>Specialization</InputLabel>
            <Select name="specialization" value={formData.specialization} onChange={handleChange} disabled={loadingSpecializations}>
              {specializations.map((spec) => (
                <MenuItem key={spec.id || spec} value={spec.name || spec}>{spec.name || spec}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField label="Consultation Fees" name="consultationFees" type="number" value={formData.consultationFees} onChange={handleChange} style={itemStyle} />
        </>
      )}
    </div>
  );

  const renderContact = (
    <div style={rowStyle}>
      <TextField label="Current Address" name="currentAddress" value={formData.currentAddress} onChange={handleChange} style={itemStyle} />
      <TextField label="Permanent Address" name="permanentAddress" value={formData.permanentAddress} onChange={handleChange} style={itemStyle} />
      <TextField label="City" name="city" value={formData.city} onChange={handleChange} style={itemStyle} />
      <TextField label="State" name="state" value={formData.state} onChange={handleChange} style={itemStyle} />
      <TextField label="ZIP / Postal Code" name="zip" value={formData.zip} onChange={handleChange} style={itemStyle} />
      <TextField label="Alternate Contact" name="altContact" value={formData.altContact} onChange={handleChange} style={itemStyle} />
    </div>
  );

  const renderPayroll = (
    <div style={rowStyle}>
      <TextField label="Salary" name="salary" value={formData.salary} onChange={handleChange} style={itemStyle} />
      <TextField label="Bank Name" name="bankName" value={formData.bankName} onChange={handleChange} style={itemStyle} />
      <TextField label="Bank Branch" name="bankBranch" value={formData.bankBranch} onChange={handleChange} style={itemStyle} />
      <TextField label="Account Number" name="accountNumber" value={formData.accountNumber} onChange={handleChange} style={itemStyle} />
      <TextField label="IFSC Code" name="ifsc" value={formData.ifsc} onChange={handleChange} style={itemStyle} />
    </div>
  );

  const renderMedical = (
    <div style={rowStyle}>
      <TextField label="Vaccinations (comma separated)" name="vaccination" value={formData.vaccination} onChange={handleChange} style={itemStyle} />
      <TextField label="Allergies" name="allergies" value={formData.allergies} onChange={handleChange} style={itemStyle} />
      <TextField label="Medical History" name="medicalHistory" value={formData.medicalHistory} onChange={handleChange} style={itemStyle} />
      <input type="file" name="healthCheckFile" onChange={handleChange} style={{ ...itemStyle, paddingTop: "10px" }} />
    </div>
  );

  const renderAttendance = (
    <div style={rowStyle}>
      <TextField label="Attendance ID" name="attendanceId" value={formData.attendanceId} onChange={handleChange} style={itemStyle} />
      <TextField label="Leave Balance" name="leaveBalance" value={formData.leaveBalance} onChange={handleChange} style={itemStyle} />
      <TextField label="Leave Entitlement" name="leaveEntitlement" value={formData.leaveEntitlement} onChange={handleChange} style={itemStyle} />
      <TextField label="Shift Preference" name="shiftPreference" value={formData.shiftPreference} onChange={handleChange} style={itemStyle} />
    </div>
  );

  const renderSystemAccess = (
    <div style={rowStyle}>
      <TextField label="Username" name="username" value={formData.username} onChange={handleChange} required style={itemStyle} disabled={!!staffId} />
      <TextField label="Password" name="password" type="password" value={formData.password} onChange={handleChange} required style={itemStyle} disabled={!!staffId} />
      <TextField label="Access Rights (comma separated)" name="accessRights" value={formData.accessRights} onChange={handleChange} style={itemStyle} />
    </div>
  );

  const renderContent = () => {
    switch (tabIndex) {
      case 0: return renderPersonalInfo;
      case 1: return renderEmployment;
      case 2: return renderContact;
      case 3: return renderPayroll;
      case 4: return renderMedical;
      case 5: return renderAttendance;
      case 6: return renderSystemAccess;
      default: return <div>Section not found</div>;
    }
  };




const filteredEmployees = employeeList.filter((emp) => {
  const search = searchTerm.toLowerCase();
  return (
    emp.employeeId?.toString().toLowerCase().includes(search) ||
    emp.firstName?.toLowerCase().includes(search) ||
    emp.lastName?.toLowerCase().includes(search) ||
    emp.email?.toLowerCase().includes(search) ||
    emp.department?.toLowerCase().includes(search) ||
    emp.username?.toLowerCase().includes(search)
  );
});






  return (
    <Card sx={{ mt: 3, boxShadow: 3, borderRadius: 3 }}>
      <CardContent>
        <Heading headingtext="Staff Profile" />
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
            {["Personal Info", "Employment", "Contact", "Payroll", "Medical", "Attendance", "System Access"].map((label, index) => (
              <Tab key={index} label={label} sx={{ color: isTabInvalid(index) ? "red" : "black" }} />
            ))}
          </Tabs>
        </Box>

        <form onSubmit={handleSubmit}>
          {renderContent()}
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
            {staffId ? "Update Staff Profile" : "Save Staff Profile"}
          </Button>
        </form>

        {/* Employee List */}
        {/* <Box sx={{
          maxHeight: 400,          // vertical scroll height
          overflowY: "auto",       // vertical scroll
          overflowX: "auto",       // horizontal scroll
          border: "1px solid #ccc",
          borderRadius: 1,
          mt: 4,
        }}>
          <Heading headingtext="Employee List" />
          <Table>
            <TableHead sx={{ backgroundColor: "primary.main" }}>
              <TableRow>
                <TableCell sx={{ color: "white" }}>Employee ID*</TableCell>
                <TableCell sx={{ color: "white" }}>First Name</TableCell>
                <TableCell sx={{ color: "white" }}>Last Name</TableCell>
                <TableCell sx={{ color: "white" }}>E-Mail*</TableCell>
                <TableCell sx={{ color: "white" }}>Login User ID*</TableCell>
                <TableCell sx={{ color: "white" }}>Job Title</TableCell>
                <TableCell sx={{ color: "white" }}>Department</TableCell>
                <TableCell sx={{ color: "white" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {employeeList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((emp) => (
                <TableRow key={emp.id}>
                  <TableCell>{emp.employeeId}</TableCell>
                  <TableCell>{emp.firstName}</TableCell>
                  <TableCell>{emp.lastName}</TableCell>
                  <TableCell>{emp.email}</TableCell>
                   <TableCell>{emp.username}</TableCell>
                  <TableCell>{emp.jobTitle}</TableCell>
                  <TableCell>{emp.department}</TableCell>
                  <TableCell>
                    <IconButton color="primary" onClick={() => handleEdit(emp)}><Edit /></IconButton>
                    <IconButton color="error" onClick={() => handleDelete(emp)}><Delete /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={employeeList.length}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          />
        </Box> */}

        {/* Employee List */}
<Box
  sx={{
    maxHeight: 500,
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ccc",
    borderRadius: 1,
    mt: 4,
    p: 2,
  }}
>
  <Heading headingtext="Employee List" />

  {/* 🔍 Search Bar */}
  <TextField
    label="Search Employee"
    variant="outlined"
    size="small"
    fullWidth
    sx={{ mb: 2 }}
    placeholder="Search by ID, Name, Email, or Department"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />

  {/* Filtered Table */}
  <Table>
    <TableHead sx={{ backgroundColor: "primary.main" }}>
      <TableRow>
        <TableCell sx={{ color: "white" }}>Employee ID*</TableCell>
        <TableCell sx={{ color: "white" }}>First Name</TableCell>
        <TableCell sx={{ color: "white" }}>Last Name</TableCell>
        <TableCell sx={{ color: "white" }}>E-Mail*</TableCell>
        <TableCell sx={{ color: "white" }}>Login User ID*</TableCell>
        <TableCell sx={{ color: "white" }}>Job Title</TableCell>
        <TableCell sx={{ color: "white" }}>Department</TableCell>
        <TableCell sx={{ color: "white" }}>Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {filteredEmployees
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((emp) => (
          <TableRow key={emp.id}>
            <TableCell>{emp.employeeId}</TableCell>
            <TableCell>{emp.firstName}</TableCell>
            <TableCell>{emp.lastName}</TableCell>
            <TableCell>{emp.email}</TableCell>
            <TableCell>{emp.username}</TableCell>
            <TableCell>{emp.jobTitle}</TableCell>
            <TableCell>{emp.department}</TableCell>
            <TableCell>
              <IconButton color="primary" onClick={() => handleEdit(emp)}>
                <Edit />
              </IconButton>
              <IconButton color="error" onClick={() => handleDelete(emp)}>
                <Delete />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  </Table>

  <TablePagination
    component="div"
    count={filteredEmployees.length}
    page={page}
    onPageChange={(e, newPage) => setPage(newPage)}
    rowsPerPage={rowsPerPage}
    onRowsPerPageChange={(e) => {
      setRowsPerPage(parseInt(e.target.value, 10));
      setPage(0);
    }}
  />
</Box>


        <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          <Alert severity={snackbar.severity} sx={{ width: "100%" }}>{snackbar.message}</Alert>
        </Snackbar>
      </CardContent>
    </Card>
  );
}
